import { RhNumberField } from '../../../../../../dum';
import React from 'react';
import { IExpense, REQUIRE_TAX, TAX } from '../expense-form';
import { useCalculateExpenseTotal } from '../use-calculate-expense-total';
import { useSetFirstExpenseResourceItem } from '../use-set-first-expense-resource-item';
import { useCalculateExpenseResourcesTotal } from '../use-calculate-expense-resources-total';
import { useFieldRevert } from '../use-field-revert';
import { RevertHint } from '../revert-hint';
import { useWatch } from 'react-hook-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function TaxInput() {
    const { calculateExpenseTotal } = useCalculateExpenseTotal();
    const { setFirstExpenseResourceItem } = useSetFirstExpenseResourceItem();
    const { calculateExpenseResourcesTotal } =
        useCalculateExpenseResourcesTotal();
    const { original, hasChanged, revert } = useFieldRevert(TAX);
    const requireTax = useWatch({
        name: REQUIRE_TAX,
    }) as IExpense['require_tax'];
    const tax = useWatch({ name: TAX }) as IExpense['tax'];
    const disableTax = !requireTax && Number(tax) === 0;

    return (
        <RhNumberField
            name={TAX}
            label={shortLabel(FIELD_LABELS.tax)}
            disabled={disableTax}
            onChange={() => {
                calculateExpenseTotal();
                setFirstExpenseResourceItem();
                calculateExpenseResourcesTotal();
            }}
            helperText={
                <RevertHint
                    hasChanged={!!requireTax && hasChanged}
                    original={original}
                    onRevert={() => {
                        revert();
                        calculateExpenseTotal();
                    }}
                />
            }
        />
    );
}
